import { useContext } from "react";
import { UseFormReturn } from "react-hook-form";
import { DateSelectComponent } from "./common/DateSelectComponent";
import { DropDownComponent } from "./common/DropDownComponent";
import { TextFieldComponent } from "./common/TextFieldComponent";
import { LookupsContext } from "./SharedUserForm";

interface formUtilsProps {
  formUtils: UseFormReturn<any, any>;
}

const GetGenderOptions = () => {
  const options = useContext(LookupsContext)
    ?.genders.filter(x => x.code !== 'U')
    .map(x => ({label: x.name!!, value: x.code!!})) ?? []
  options.unshift({label: 'Select gender / sex', value: ''})
  return options
}

export const UserDetails = ({ formUtils }: formUtilsProps) => {
  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = formUtils
  
  const options = GetGenderOptions();
  
  return (
    <>
      <TextFieldComponent
        label="First name / given name"
        id="firstName"
        required
        register={register}
        errors={errors}
      />
      <TextFieldComponent
        label="Last name / surname"
        id="lastName"
        required
        register={register}
        errors={errors}
      />
    </>
  );
};
